import peaq from "../assets/images/car_marks/peaq.webp";
import epiq from "../assets/images/car_marks/epiq.webp";
import elroq from "../assets/images/car_marks/elroq.png";
import fabia from "../assets/images/car_marks/fabia.png";
import karoq from "../assets/images/car_marks/karoq.png";
import nowa_octavia from "../assets/images/car_marks/nowa_octavia.png";
import nowa_scala from "../assets/images/car_marks/nowa_scala.png";
import enyaq from "../assets/images/car_marks/nowy_enyaq.png";
import enyaq_coupe from "../assets/images/car_marks/enyaq_coupe.png";
import nowy_kamiq from "../assets/images/car_marks/nowy_kamiq.png";
import kodiaq from "../assets/images/car_marks/nowy_kodiaq.png";
import nowy_superb from "../assets/images/car_marks/nowy_superb.png";
import close from "../assets/images/close.png";

export const carMarks = [
  {
      name: "Peaq",
      image: peaq,
      slug: "peaq",
      desc: "W pełni elektryczny SUV z miejscem dla nawet siedmiu osób"
  },
    {
        name: "Epiq",
        image: epiq,
        slug: "epiq",
        desc: "Nowa, w pełni elektryczna Škoda Epiq"
    },
    {
        name: "Enyaq",
        image: enyaq,
        slug: "enyaq",
        desc: "W pełni elektryczny SUV"
    },
    {
        name: "Enyaq Coupe",
        image: enyaq_coupe,
        slug: "enyaq_coupe",
        desc: "Zachwycający design, elektryczny napęd"
    },
    {
        name: "Kodiaq",
        image: kodiaq,
        slug: "kodiaq",
        desc: "Odkryj nowy rodzaj przestrzeni i solidności"
    },
    {
        name: "Elroq",
        image: elroq,
        slug: "elroq",
        desc: "W pełni elektryczny kompaktowy SUV"
    },
    {
        name: "Superb",
        image: nowy_superb,
        slug: "superb",
        desc: "Połączenie elegancji i luksusu"
    },
    {
        name: "Karoq",
        image: karoq,
        slug: "karoq",
        desc: "Kompaktowy SUV"
    },
    {
        name: "Octavia",
        image: nowa_octavia,
        slug: "octavia",
        desc: "Najnowsza edycja bestsellera marki"
    },
    {
        name: "Kamiq",
        image: nowy_kamiq,
        slug: "kamiq",
        desc: "Miejski SUV z nowatorskim designem"
    },
    {
        name: "Scala",
        image: nowa_scala,
        slug: "scala",
        desc: "Kompaktowy hatchback o dynamicznym wyglądzie"
    },
    {
        name: "Fabia",
        image: fabia,
        slug: "fabia",
        desc: "Nowoczesny design i technologia"
    },
]

const SkodaCarMarks = ({ onClose, onCarSelect }) => {
    const handleCarClick = (carMark) => {
        onCarSelect(carMark);
    };

    return (
        <>
            <div className="cars-container">
                <div className="cars-content">
                    <h2>Wybierz model, którego ofertę chcesz poznać</h2>
                    <div className="close-button" onClick={onClose}>
                        <img src={close} alt="close" />
                    </div>

                    <div className="cars-content__list">
                        {carMarks.map((carMark, index) => (
                            <div
                                key={index}
                                className="cars-content__list-item"
                                onClick={() => handleCarClick(carMark)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="cars-content__list-item-image">
                                    <img src={carMark.image} alt={carMark.name} />
                                    <h3>{carMark.name}</h3>
                                    <p dangerouslySetInnerHTML={{ __html: carMark.desc }}></p>
                                </div>
                            </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default SkodaCarMarks;
